module.exports = __webpack_public_path__ + "img/recordNumber.856cd5a0.png";